import ResponsavelUsuarioCSVSchema from '@/schema/ResponsavelUsuarioCsv.schema'
import ResponsavelUsuario from '@/model/resource/ResponsavelUsuario'

export default class ResponsavelUsuarioCSV extends ResponsavelUsuario {
  get $schema() {
    return ResponsavelUsuarioCSVSchema(this)
  }
}
